module.exports = __webpack_public_path__ + "img/lamp_ico.a60102cf.svg";